import goalsA from "../../../assets/imgs/goals-a.png";
import goalsB from "../../../assets/imgs/goals-b.png";
import goalsC from "../../../assets/imgs/goals-c.png";
import goalsD from "../../../assets/imgs/goals-d.png";
import goalsE from "../../../assets/imgs/goals-e.png";
import goalsF from "../../../assets/imgs/goals-f.png";

import frustrationsA from "../../../assets/imgs/frustrations-a.png";
import frustrationsB from "../../../assets/imgs/frustrations-b.png";
import frustrationsC from "../../../assets/imgs/frustrations-c.png";
import frustrationsD from "../../../assets/imgs/frustrations-d.png";
import frustrationsE from "../../../assets/imgs/frustrations-e.png";
import frustrationsF from "../../../assets/imgs/frustrations-f.png";

import confidenceA from "../../../assets/imgs/confidence-a.png";
import confidenceB from "../../../assets/imgs/confidence-b.png";
import confidenceC from "../../../assets/imgs/confidence-c.png";
import confidenceD from "../../../assets/imgs/confidence-d.png";

import leagueTypeA from "../../../assets/imgs/league-type-a.png";
import leagueTypeB from "../../../assets/imgs/league-type-b.png";
import leagueTypeC from "../../../assets/imgs/league-type-c.png";
import leagueTypeD from "../../../assets/imgs/league-type-d.png";
import leagueTypeE from "../../../assets/imgs/league-type-e.png";
import leagueTypeF from "../../../assets/imgs/league-type-f.png";

import numLeaguesA from "../../../assets/imgs/num-leagues-a.png";
import numLeaguesB from "../../../assets/imgs/num-leagues-b.png";
import numLeaguesC from "../../../assets/imgs/num-leagues-c.png";
import numLeaguesD from "../../../assets/imgs/num-leagues-d.png";

// Define onboarding step types
export interface OnboardingStep {
  id: number;
  title: string;
  options: {
    icon: string;
    text: string;
    iconAlt?: string;
    value: string;
    event: string;
  }[];
  allowMultipleSelection?: boolean;
  showBackButton?: boolean;
  field: string;
  event?: string;
}

// Onboarding Goals Data
export const OnboardingGoals = [
  {
    icon: goalsA,
    text: "Win my fantasy football league",
    iconAlt: "goalsA",
    value: "Win my fantasy football league",
    event: "onboarding_goals_answer_a",
  },
  {
    icon: goalsB,
    text: "Smarter insights for weekly decisions",
    iconAlt: "goalsB",
    value: "Smarter insights for weekly decisions",
    event: "onboarding_goals_answer_b",
  },
  {
    icon: goalsC,
    text: "Explore tools to help with sports betting",
    iconAlt: "goalsC",
    value: "Explore tools to help with sports betting",
    event: "onboarding_goals_answer_c",
  },
  {
    icon: goalsD,
    text: "Access and explore advanced stats",
    iconAlt: "goalsD",
    value: "Access and explore advanced stats",
    event: "onboarding_goals_answer_d",
  },
  {
    icon: goalsE,
    text: "Test out AI for football insights",
    iconAlt: "goalsE",
    value: "Test out AI for football insights",
    event: "onboarding_goals_answer_e",
  },
  {
    icon: goalsF,
    text: "Still exploring / not sure yet",
    iconAlt: "goalsF",
    value: "Still exploring / not sure yet",
    event: "onboarding_goals_answer_f",
  },
];

// Onboarding Experience Levels Data
export const OnboardingFrustrations = [
  {
    icon: frustrationsA,
    text: "I always make the wrong sit/start call",
    iconAlt: "frustrationsA",
    value: "I always make the wrong sit/start call",
    event: "onboarding_frustrations_answer_a",
  },
  {
    icon: frustrationsB,
    text: "I miss waiver wire pickups",
    iconAlt: "frustrationsB",
    value: "I miss waiver wire pickups",
    event: "onboarding_frustrations_answer_b",
  },
  {
    icon: frustrationsC,
    text: "I lose trades or don’t get good value",
    iconAlt: "frustrationsC",
    value: "I lose trades or don’t get good value",
    event: "onboarding_frustrations_answer_c",
  },
  {
    icon: frustrationsD,
    text: "I don’t have  time to do enough research",
    iconAlt: "frustrationsD",
    value: "I don’t have  time to do enough research",
    event: "onboarding_frustrations_answer_d",
  },
  {
    icon: frustrationsE,
    text: "I don’t know who to trust for advice",
    iconAlt: "frustrationsE",
    value: "I don’t know who to trust for advice",
    event: "onboarding_frustrations_answer_e",
  },
  {
    icon: frustrationsF,
    text: "Other",
    iconAlt: "frustrationsF",
    value: "Other",
    event: "onboarding_frustrations_answer_f",
  },
];

// Onboarding Confidence Data
export const OnboardingConfidence = [
  {
    icon: confidenceA,
    text: "Total beginner",
    iconAlt: "confidenceA",
    value: "beginner",
    event: "onboarding_confidence_answer_a",
  },
  {
    icon: confidenceB,
    text: "Somewhat experienced",
    iconAlt: "confidenceB",
    value: "somewhat-experienced",
    event: "onboarding_confidence_answer_b",
  },
  {
    icon: confidenceC,
    text: "Very experienced",
    iconAlt: "confidenceC",
    value: "very-experienced",
    event: "onboarding_confidence_answer_c",
  },
  {
    icon: confidenceD,
    text: "Expert level",
    iconAlt: "confidenceD",
    value: "expert",
    event: "onboarding_confidence_answer_d",
  },
];

// Onboarding League Type Data
export const OnboardingLeagueType = [
  {
    icon: leagueTypeA,
    text: "Redraft (Most Common)",
    iconAlt: "leagueTypeA",
    value: "redraft",
    event: "onboarding_league_type_answer_a",
  },
  {
    icon: leagueTypeB,
    text: "Dynasty",
    iconAlt: "leagueTypeB",
    value: "dynasty",
    event: "onboarding_league_type_answer_b",
  },
  {
    icon: leagueTypeC,
    text: "Keeper",
    iconAlt: "leagueTypeC",
    value: "keeper",
    event: "onboarding_league_type_answer_c",
  },
  {
    icon: leagueTypeD,
    text: "Best Ball",
    iconAlt: "leagueTypeD",
    value: "best-ball",
    event: "onboarding_league_type_answer_d",
  },
  {
    icon: leagueTypeE,
    text: "I’m in multiple league formats",
    iconAlt: "leagueTypeE",
    value: "multiple",
    event: "onboarding_league_type_answer_e",
  },
  {
    icon: leagueTypeF,
    text: "Not in a league (just here for betting/stats)",
    iconAlt: "leagueTypeF",
    value: "none",
    event: "onboarding_league_type_answer_f",
  },
];

// Onboarding Number of Leagues Data
export const OnboardingNumLeagues = [
  {
    icon: numLeaguesA,
    text: "Just one",
    iconAlt: "numLeaguesA",
    value: "1",
    event: "onboarding_num_leagues_answer_a",
  },
  {
    icon: numLeaguesB,
    text: "2-3",
    iconAlt: "numLeaguesB",
    value: "2-3",
    event: "onboarding_num_leagues_answer_b",
  },

  {
    icon: numLeaguesC,
    text: "4+",
    iconAlt: "numLeaguesC",
    value: "4+",
    event: "onboarding_num_leagues_answer_c",
  },

  {
    icon: numLeaguesD,
    text: "Not in a league this year",
    iconAlt: "numLeaguesD",
    value: "none",
    event: "onboarding_num_leagues_answer_d",
  },
];

// Define onboarding steps data using the arrays above
export const onboardingSteps: OnboardingStep[] = [
  {
    id: 1,
    title: "What are you hoping to get out of RotoBot?",
    allowMultipleSelection: true,
    showBackButton: false,
    options: OnboardingGoals,
    field: "goal",
    event: "onboarding_goals_continue_selected",
  },
  {
    id: 2,
    title: "What’s been your biggest frustration with fantasy or betting?",
    allowMultipleSelection: true,
    showBackButton: true,
    options: OnboardingFrustrations,
    field: "frustration",
    event: "onboarding_frustrations_continue_selected",
  },
  {
    id: 3,
    title: "How confident are you in your skills?",
    allowMultipleSelection: false,
    showBackButton: true,
    options: OnboardingConfidence,
    field: "confidence_level",
    event: "onboarding_confidence_continue_selected",
  },

  {
    id: 4,
    title: "What type of fantasy league are you playing in?",
    allowMultipleSelection: false,
    showBackButton: true,
    options: OnboardingLeagueType,
    field: "league_type",
    event: "onboarding_league_type_continue_selected",
  },

  {
    id: 5,
    title: "How many leagues are you in this season?",
    allowMultipleSelection: false,
    showBackButton: true,
    options: OnboardingNumLeagues,
    field: "league_count_category",
    event: "onboarding_num_leagues_continue_selected",
  },
];
